import { useEffect, useState } from "react";
import "../../assets/styles/Profile/Profile.css";
import "../../assets/styles/products/product.css";
import NavbarHome from "../home/NavbarNew/NavbarHome";
// import FootNav from "../User_Profile/Footer/Footer-nav/FootNav";
import { Server2 } from "../../redux/actions/auth/auth.actions";
import axios from "axios";
import { Button } from "react-bootstrap";
import { BsArrowLeftCircle, BsCart2 } from "react-icons/bs";
import { useDispatch } from "react-redux";
import { addToCart } from "../../redux/actions/cart/cart.actions";
import { useNavigate, useParams } from "react-router-dom";
import FootNav from "../User_Profile/Footer/Footer-nav/FootNav";
import { IoCardOutline } from 'react-icons/io5';
import StarRating from "../../components/product/StarRating";
import Catalogue from "../../components/product/Catalogue";
import ProductReviews from "../../components/product/Reviews";
import { toast, ToastContainer } from "react-toastify";
import { slugify } from "../../utils";
import { LoaderLinearDots } from "../../components/LoaderLinear";
const MyProduct = () => {

  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);

  const handleAddToCart = (product, flag) => {

    if (!selectedSize && product.variants?.sizes?.length > 0) {
      setErrors('size')
      toast.warning('Please select a size', {
          position: "bottom-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      return;
    }

    if (!selectedColour && product.variants?.colors?.length > 0) {
      setErrors('colour');
      toast.warning('Please select a color', {
          position: "bottom-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      return;
    }

    dispatch(
      addToCart({
        productId: product._id,
        productName: product.productName,
        price: product.price,
        taxCode: product.taxCode ? product.taxCode : 'txcd_10000000',
        shippingCost: product?.type === 'physical' ? product?.shipping?.shippingCost : 0,
        variants: {
          color: selectedColour,
          size: selectedSize,
        },
        image: product.images[0],
        sellerId: product.userId,
      })
    );

    if(flag !== undefined) navigate('/my-cart')

  };

  const [image, setImage] = useState(null);
  const [Product, setProduct] = useState('');
  const [selectedSize, setSelectedSize] = useState(null);
  const [Errors, setErrors] = useState(null);
  const [selectedColour, setSelectedColour] = useState(null);
  const zoom = 2

  const getProduct = () => {

    let data = JSON.stringify({
      id: id,
    });

    var config = {
      method: "post",
      url: Server2 + "/products/get-by-id",
      headers: { "Content-Type": "application/json" },
      data: data,
    };
    axios(config)
      .then((response) => {
        console.log(response.data, 'im prods')
        setImage(response.data?.images[0])
        setProduct(response.data);
      })
      .catch((err) => {
        console.log(err, "error");
      }).finally(() => setIsLoading(false));
  }

  useEffect(() => {
    getProduct();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [position, setPosition] = useState({ x: 0, y: 0, show: false });

  const handleMouseMove = (e) => {
    const { left, top, width, height } = e.target.getBoundingClientRect();

    const x = ((e.pageX - left) / width) * 100;
    const y = ((e.pageY - top) / height) * 100;

    setPosition({ x, y, show: true });
  };

  return (

    <div className="bg-white d-flex flex-column" style={{ height: '100dvh' }}>
      <NavbarHome />
      <div className="px-3 flex-grow-1">
        { isLoading? <div className='mx-auto mt-5 d-flex justify-content-center'>
            <LoaderLinearDots/>
          </div> : !isLoading && !Product ?
          <p className="fs-6 text-capitalize rounded text-center pt-1" style={{ backgroundColor: "#ececec", width: "105px", height: "86px", marginBottom: "-1px" }}>No Product</p>
          :
          <div className="row bg-white">

            {/* Column Images & Gallery */}
            <div className="col-lg-1 col-md-0 col-sm-0 pb-2 d-flex justify-content-center">
              <BsArrowLeftCircle size={42} className="ib-color mt-4 cursor-pointer" title="Back to Profile"
                onClick={() => navigate(`/profile/${Product?.userId?._id}/${slugify(Product?.userId?.fname)}`, { state: { item: Product?.userId?._id } })}
              />
            </div>
            <div className="col-lg-4 col-md-12 col-sm-12 pb-2 d-flex flex-column">
              <div className=""
                onMouseMove={handleMouseMove}
                onMouseLeave={() => setPosition({ ...position, show: false })}
              >
                <img
                  className="rounded-3 img-product-feature"
                  src={image}
                  alt={"Images Product"}
                />
              </div>
              <div className="d-flex Gal-Main gap-3 my-2">
                {!Product?.images ?
                  <p className=" fs-6 text-capitalize rounded text-center pt-1" style={{ backgroundColor: "#ececec", width: "105px", height: "86px", marginBottom: "-1px" }}>No image</p>
                  : Product?.images?.map((imgs, index) => {
                  return (
                    <div className='position-relative img-product-box' key={index}>
                      <img
                        onClick={() => setImage(Product?.images[index])}
                        key={index}
                        className="rounded-3 img-product"
                        src={imgs}
                        alt={"Images Product"}
                      />
                    </div>
                  );
                })}
              </div>
              <div className="d-flex gap-2">
                <Button className='w-100 d-flex gap-2 justify-content-center btn-ibouge-outline'
                  disabled={Product?.stock < 1 && Product?.type !== 'digital'}
                  onClick={()=> handleAddToCart(Product)}>
                  Add to Cart
                  <BsCart2 style={{ marginTop: '2px' }}/>
                </Button>

                <Button className='w-100 d-flex gap-2 justify-content-center btn-ibouge'
                  disabled={Product?.stock < 1 && Product?.type !== 'digital'}
                  onClick={()=> {
                    handleAddToCart(Product, 'navigate');
                  }}>
                  Buy Now
                  <IoCardOutline style={{ marginTop: '3px' }}/>
                </Button>
              </div>
            </div>

            {/* Column Description */}
            <div className="col-lg-4 offset-1 col-md-12 col-sm-12">
              <div className='p-1'>
                <h5 className=''>{Product?.productName}</h5>
                {Product.ratingCount > 0 &&
                <div className="d-flex align-items-baseline">
                  <StarRating value={Product.ratingAvg} disabled onChange={()=>{}} />
                  <p className="ms-2 me-2">{Product.ratingAvg.toFixed(1)}</p><span>{Product.ratingCount} user(s)</span>
                </div>
                }

              </div>
              <div className='mt-2 pt-1'>
                <button type="button" class="btn btn-sm btn-ibouge-outline rounded-5 mx-1 px-3">{Product?.type?.toUpperCase()}</button>
                {/* {Product?.subCategory ? 
                <button type="button" class="btn btn-sm btn-ibouge-outline rounded-5 mx-1 px-3">{Product.subCategory}</button>: null} */}
              </div>
              <div className='px-2 pt-3 my-3'>
                <div className="">
                  <h6 className='lh-1 text-black'>Price: ${Product?.price}</h6>
                  {/* <h6 className='lh-1 text-black'>Price: ${Product?.price} <span className='lh-1'>({Product.stock})</span></h6> */}
                  {Product?.stock > 0 || Product?.type === 'digital' ?
                    <p className='lh-1 fw-bolder' style={{ color: '#6148A1' }}>In Stock</p>
                    :
                    <p className='lh-1' style={{ color: 'red' }}>Out of Stock</p>
                  }
                </div>
                <h6 className="mb-0 mt-3 text-black">Description:</h6>
                <p className="mb-4">{Product?.description}</p>
                <div className="variants-wrapper">
                  {Product?.variants?.sizes?.map((value, index) => {
                    const isSelected = selectedSize === value;

                    return (
                      <button
                        type="button"
                        key={index}
                        className={`variant-item ${isSelected ? "active" : Errors === 'size' ? 'error' : ''}`}
                        onClick={() => {setSelectedSize(value); setErrors(null)}}
                      >
                        <span className="variant-label">sizes:</span>
                        <span className="variant-value">{value}</span>
                      </button>
                    );
                  })}
                </div>
                <div className="variants-wrapper mt-2">
                  {Product?.variants?.colors?.map((value, index) => {
                    const isSelected = selectedColour === value;

                    return (
                      <button
                        type="button"
                        key={index}
                        className={`variant-item ${isSelected ? "active" : Errors === 'colour' ? 'error' : ''}`}
                        onClick={() => {setSelectedColour(value); setErrors(null)}}
                      >
                        <span className="variant-label">colors:</span>
                        <span className="variant-value">{value}</span>
                      </button>
                    );
                  })}
                </div>
                <div className="mt-4 pt-2">
                  <h6 className="mb-0 text-black">Product By</h6>
                  <p>{Product.userId.fname}</p>
                  {/* <h6 className="mt-2 mb-0 text-black">Seller From</h6>
                  <p><span class="fi fi-gb"></span>London, East Coast</p> */}
                </div>
              </div>
            </div>

            <div className="col-lg-10 offset-1 col-md-12 col-sm-12 mb-4 mt-3">
              <ProductReviews productId={Product._id}/>
            </div>

            <div className="col-lg-10 offset-1 col-md-12 col-sm-12 mb-5 mt-3">
              <div>
                <h6 className="px-2 mb-0">Similar Products</h6>
                <Catalogue setImage={setImage} setProduct={setProduct} userId={Product.userId._id}/>
              </div>
            </div>

            <ToastContainer />
          </div>
        }
      </div>
      <FootNav />
      {position.show && (
        <div className="magnifier-overlay">
          <div
            className="magnifier-center"
            style={{
              backgroundImage: `url(${image})`,
              backgroundPosition: `${position.x}% ${position.y}%`,
              backgroundSize: `${zoom * 200}%`,
            }}
          />
        </div>
      )}
    </div>
  );
};

export default MyProduct;